import { Injectable, OnInit } from '@angular/core';
import { ConfigService } from './config.service';
import { Http } from '@angular/http';
import { CustomHttp } from './custom.http';
import { EntityType } from '../common/model/constant';

@Injectable()
export class ApiConstants {
    [x: string]: any;


    public HELPDESK_API_URL;
    public ES_SERVICE;
    public DATA_API_URL;
    public CATALOG_API_URL;

    public GLOBAL_TREND_API_URL = 'http://ec2-52-91-57-114.compute-1.amazonaws.com:8010';
    public BASE_DEMAND_PORTAL_V2 = '/demandportalv2';
    public ENDPOINT_ACCOUNT = '/account';
    public ENDPOINT_SUBSCRIPTIONS = '/subscriptions/v2';
    public ENDPOINT_USER = '/user';
    public ENDPOINT_ROLE = '/role';
    public ENDPOINT_CUSTOMTER = '/customer';
    public ENDPOINT_PROXY = '/proxy?';
    public ENDPOINT_QA_REQUESTS = '/qa_requests';
    public ENDPOINT_NOTIFICATIONS = '/notifications';
    public ENDPOINT_TITLE_REQUESTS = '/title_requests';
    public ENDPOINT_HARVESTED_QA = '/harvested_qa';
    public ENDPOINT_SCHEDULING = '/scheduling';

    public ENDPOINT_HELPDESK_CUSTOMER = this.ENDPOINT_PROXY + 'service=demand360&uri=' + this.ENDPOINT_CUSTOMTER;
    public ENDPOINT_HELPDESK_ACCOUNT = this.ENDPOINT_PROXY + 'service=demand360&uri=' + this.ENDPOINT_ACCOUNT;
    public ENDPOINT_HELPDESK_ALL_ACCOUNT = this.ENDPOINT_PROXY + 'service=demand360&uri=' + this.ENDPOINT_ACCOUNT + '?account_type=all';
    public ENDPOINT_HELPDESK_USER = this.ENDPOINT_PROXY + 'service=demand360&uri=' + this.ENDPOINT_USER;
    public ENDPOINT_USER_SETTINGS = this.ENDPOINT_HELPDESK_USER + '/allsetting';

    public ENDPOINT_HELPDESK_ROLE = this.ENDPOINT_PROXY + 'service=demand360&uri=' + this.ENDPOINT_ROLE;
    public ENDPOINT_HELPDESK_SUBSCRIPTIONS = this.ENDPOINT_PROXY + 'service=demand360&uri=' + this.ENDPOINT_SUBSCRIPTIONS;
    public ENDPOINT_HELPDESK_SUBSCRIPTIONS_DIRECT = this.DATA_API_URL  + this.ENDPOINT_SUBSCRIPTIONS;

    public ENDPOINT_SYSOPS = this.ENDPOINT_PROXY + 'service=demand360&uri=/v2/sysops/clearcaches?cacheType=all';


    public ALL_TITLES_URL = this.ENDPOINT_HELPDESK_SUBSCRIPTIONS + '/0/tvtitle/all';
    public ALL_MARKETS_URL = this.ENDPOINT_HELPDESK_SUBSCRIPTIONS + '/0/market/all';
    public ALL_PRODUCT_URL = this.ENDPOINT_HELPDESK_SUBSCRIPTIONS + '/0/module/all';

    public ALL_USERS_URL = this.ENDPOINT_HELPDESK_USER + '/all';


    // Catalog API
    public META_DATA_URL = this.ENDPOINT_PROXY + 'service=catalogapi&uri=/v1/metadata/tv?key=gx4tG2hALXWgQt7o4YTU&query=';
    public META_DATA_ENTENDED_URL = '&extended=true&internal=true&images=true';
    public ALL_CATALOG_URL = this.ENDPOINT_PROXY + 'service=catalogapi&uri=/v1/catalog/tv';
    public GENOME_UPDATE_URL = this.ENDPOINT_PROXY + 'service=catalogapi&uri=/v1/enrich/updategenome/tv';
    public GENOME_NOTE_URL = this.ENDPOINT_PROXY + 'service=catalogapi&uri=/v1/enrich/note';

    // Constants from Catalog API
    public GENRES;
    public GENRE_TAGS;
    public MOVIE_GENRE_TAGS;
    public OCCUPATION_TAGS;
    public TV_STATUS;
    public VERIFICATION_STATUS;
    public TV_SERIES_TYPE;
    public SPORTS_CONTENT_SUB_TYPE;
    public SPORTS_GAME;

    public SPORTS_ENVIRONMENT;
    public SPORTS_PARTICIPATION;
    public SPORTS_GAME_TYPE;
    public SPORTS_SKILL_SET;
    public SPORTS_EVENT_FREQUENCY;

    public MOVIE_STATUS;
    public GENDER;
    public COUNTRIES;
    public LANGUAGES;
    public NETWORKS;
    public CONTENT_TYPES;
    public CONTENT_SUB_TYPES;

    // Available accounts from Data API
    public ACCOUNTS;

    constructor(private configService: ConfigService) {
        // Overwrite values loaded from the config service
        this.HELPDESK_API_URL = configService.HELPDESK_API_URL;
        this.ES_SERVICE = configService.ES_SERVICE;
        this.DATA_API_URL = configService.DATA_API_URL;
        this.CATALOG_API_URL = configService.CATALOG_API_URL;
        this.GENRES = configService.GENRES;
        this.GENRE_TAGS = configService.GENRE_TAGS && configService.GENRE_TAGS.sort();
        this.MOVIE_GENRE_TAGS = ['action', 'adventure', 'animation', 'children', 'comedy', 'crime', 'documentary', 'drama', 'family', 'fantasy', 'history', 'horror', 'music', 'musical', 'mystery', 'romance', 'science fiction', 'thriller', 'war', 'western'];
        this.OCCUPATION_TAGS = configService.OCCUPATION_TAGS && configService.OCCUPATION_TAGS.sort();
        this.TV_STATUS = configService.TV_STATUS && configService.TV_STATUS.sort((a, b) => a.name < b.name ? -1 : 1 );
        this.VERIFICATION_STATUS = configService.VERIFICATION_STATUS && configService.VERIFICATION_STATUS.sort((a, b) => a.name < b.name ? -1 : 1 );
        this.TV_SERIES_TYPE = configService.TV_SERIES_TYPE && configService.TV_SERIES_TYPE.sort((a, b) => a.name < b.name ? -1 : 1 );
        this.SPORTS_CONTENT_SUB_TYPE = configService.SPORTS_CONTENT_SUB_TYPE && configService.SPORTS_CONTENT_SUB_TYPE.sort((a, b) => a.name < b.name ? -1 : 1 );
        this.SPORTS_GAME = configService.SPORTS_GAME && configService.SPORTS_GAME.sort((a, b) => a.name < b.name ? -1 : 1 );
        this.SPORTS_ENVIRONMENT = configService.SPORTS_ENVIRONMENT && configService.SPORTS_ENVIRONMENT.sort((a, b) => a.name < b.name ? -1 : 1);
        this.SPORTS_PARTICIPATION = configService.SPORTS_PARTICIPATION && configService.SPORTS_PARTICIPATION.sort((a, b) => a.name < b.name ? -1 : 1);
        this.SPORTS_GAME_TYPE = configService.SPORTS_GAME_TYPE && configService.SPORTS_GAME_TYPE.sort((a, b) => a.name < b.name ? -1 : 1);
        this.SPORTS_SKILL_SET = configService.SPORTS_SKILL_SET && configService.SPORTS_SKILL_SET.sort((a, b) => a.name < b.name ? -1 : 1);
        this.SPORTS_EVENT_FREQUENCY = configService.SPORTS_EVENT_FREQUENCY && configService.SPORTS_EVENT_FREQUENCY.sort((a, b) => a.name < b.name ? -1 : 1);
        this.MOVIE_STATUS = configService.MOVIE_STATUS && configService.MOVIE_STATUS.sort((a, b) => a.name < b.name ? -1 : 1 );
        this.GENDER = configService.GENDER && configService.GENDER.sort((a, b) => a.name < b.name ? -1 : 1 );
        this.COUNTRIES = configService.COUNTRIES && configService.COUNTRIES.sort((a, b) => a.name < b.name ? -1 : 1 );
        this.LANGUAGES = configService.LANGUAGES && configService.LANGUAGES.sort((a, b) => a.name < b.name ? -1 : 1 );
        this.NETWORKS = configService.NETWORKS && configService.NETWORKS.sort((a, b) => a.name < b.name ? -1 : 1 );
        this.CONTENT_TYPES = configService.CONTENT_TYPES;
        this.CONTENT_SUB_TYPES = configService.CONTENT_SUB_TYPES;
    }


    public getPortalRefreshCacheUrl() {
        return `${this.ENDPOINT_SYSOPS}`;
    }

    public getUserByIdUrl(userId: number) {
        return `${this.ENDPOINT_HELPDESK_USER}?userId=${userId}`;
    }

    public getUser() {
        return `${this.ENDPOINT_HELPDESK_USER}`;
    }

    public getUserWelcomeEmailUrl(userId: number) {
        return `${this.ENDPOINT_HELPDESK_USER}/welcomeEmail?userId=${userId}`;
    }

    public getSubscriptionByAccountUrl(accountId: number) {
        return `${this.ENDPOINT_HELPDESK_SUBSCRIPTIONS}/${accountId}`;
    }


    public getSubscriptionByAccountInternalUrl(accountId: number) {
        return `${this.ENDPOINT_HELPDESK_SUBSCRIPTIONS}/${accountId}?internal=true`;
    }

    public getSubscriptionByAccountRefMarket(accountId: number, marketId: number) {
        return `${this.ENDPOINT_HELPDESK_SUBSCRIPTIONS}/${accountId}/market?marketId=${marketId}`;
    }

    public postSubscriptionByAccountRefMarket(accountId: number, marketId: number) {
        return `${this.ENDPOINT_HELPDESK_SUBSCRIPTIONS}/${accountId}/market?marketId=${marketId}`;
    }

    public postMarketSubscriptionByAccountIdAndEntityType(accountId: number, entityType: EntityType) {
        return `${this.ENDPOINT_HELPDESK_SUBSCRIPTIONS}/${accountId}/MARKET/${entityType}`;
    }

    public deleteSubscriptionByAccountIdAndEntityType(accountId: number, marketId: number, entityType: EntityType) {
        return `${this.ENDPOINT_HELPDESK_SUBSCRIPTIONS}/${accountId}/MARKET/${entityType}?marketIds=${marketId}`;
    }

    public getSubscriptionByAccountRefTitle(accountId: number, parrotId: string) {
        return `${this.ENDPOINT_HELPDESK_SUBSCRIPTIONS}/${accountId}/tvtitle?titleId=${parrotId}`;
    }

    public getSubscriptionByAccountRefModule(accountId: number, moduleId: number) {
        return `${this.ENDPOINT_HELPDESK_SUBSCRIPTIONS}/${accountId}/module?moduleId=${moduleId}`;
    }

    public getAccountByCustomerUrl(customerId: number) {
        return `${this.ENDPOINT_HELPDESK_ACCOUNT}?customerId=${customerId}`;
    }

    public getAccountByIdUrl(accountId: number) {
        return `${this.ENDPOINT_HELPDESK_ACCOUNT}?accountId=${accountId}`;
    }

    public getCustomerByIdUrl(customerId: number) {
        return `${this.ENDPOINT_HELPDESK_CUSTOMER}?customerId=${customerId}`;
    }

    /* call this DATA_API directly now */
    public getSubscriptionCustomersUrl() {
        return `${this.ENDPOINT_HELPDESK_ACCOUNT}?account_type=subscription`;
    }

    getSubscriptionsByAccountUrl(accountId: number) {
        return `${this.ENDPOINT_HELPDESK_SUBSCRIPTIONS}/${accountId}`;
    }

    getUserSettingUrl(type?) {
        if (type) {
            return this.ENDPOINT_USER_SETTINGS + '?settingType=' + type;
        } else {
            return this.ENDPOINT_USER_SETTINGS;
        }
    }

    // Catalog API

    /* call this DATA_API directly now */
    public getCatalogURL(query: string) {
        return `${this.META_DATA_URL}${query}` + this.META_DATA_ENTENDED_URL;
    }

    public getAllCatalogueURL() {
        return this.ALL_CATALOG_URL;
    }

    public updateGenomeURL() {
        return this.GENOME_UPDATE_URL;
    }

    public updateNotesURL(operation?) {
        let url = this.GENOME_NOTE_URL;
        if (operation) {
            url += '/' + operation;
        }
        return url;
    }

    public getAccounts(customHttp: CustomHttp) {
        return new Promise((resolve, reject) => {
            if (this.ACCOUNTS) {
                resolve(this.ACCOUNTS);
            } else {
                customHttp.get(`/proxy?service=demand360&uri=/account`)
                    .then(res => {
                        this.ACCOUNTS = res.user_accounts.map(item => {
                            if (item.account_id === 99) {
                                // Customer ready
                                return {
                                    id: 99,
                                    name: 'Customer Ready'
                                };
                            } else {
                                return {
                                    id: item.account_id,
                                    name: item.account_name
                                };
                            }
                        });
                        resolve(this.ACCOUNTS);
                    });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/api.constants.ts